import styles from './LoginForm.module.scss';
import { useNavigate, Navigate } from 'react-router-dom';
import { AppRoutes, AuthRoutes } from '../../../routes/routeConstants/appRoutes';
import { useAuth } from '../../../context/AuthContext';
import { Button, notification } from 'antd';
import InputField from '../../../shared/components/InputField';
import { InputFieldType } from '../../../enums/inputFieldTypes';
import { FieldLabels, FieldNames, loginFormValidation } from './constants';
import Form from '../../../shared/components/Form';
import { ItemSize } from '../../../enums/sizeEnums';
import { InputStyle } from '../../../enums/inputEnums';
import { FieldValues } from 'react-hook-form';
import AuthService from '../../../services/AuthService/authService.service';
import { useMutation } from '@tanstack/react-query';
import { ButtonHtmlType } from '../../../enums/buttomEnums';
import { useRef } from 'react';

const LoginForm: React.FC = () => {
  const { emailField, passwordField } = FieldNames;
  const { EMAIL, PASSWORD } = FieldLabels;
  const { authenticated: isAuthenticated } = useAuth();

  const { loginUser } = AuthService();
  const { mutate, isPending } = useMutation(loginUser());

  const navigate = useNavigate();
  const resetPasswordRef = useRef<(() => void) | null>(null);

  if (isAuthenticated) return <Navigate to={AppRoutes.HOME} replace />;

  const handleForgetNavigate = () => {
    if (!isPending) navigate(AuthRoutes.FORGOT_PASSWORD);
  };

  const handleLogin = (values: FieldValues) => {
    notification.destroy();
    mutate(
      {
        email: values.email,
        password: values.password,
      },
      {
        onSuccess: () => {
          navigate(AppRoutes.HOME);
        },
        onError: () => {
          resetPasswordRef.current?.();
        },
      },
    );
  };

  return (
    <div className={styles.centeredContainer}>
      <div className={styles.innerContainer}>
        <div className={styles.header}>
          <h1>SIGN IN TO MAPAKI</h1>
        </div>
        <div className={styles.fieldsContainer}>
          <Form validationSchema={loginFormValidation} onSubmit={handleLogin}>
            {(methods) => {
              resetPasswordRef.current = () => methods.resetField(passwordField);
              return (
                <>
                  <InputField type={InputFieldType.TEXT} name={emailField} label={EMAIL} inputStyle={InputStyle.LOGIN} size={ItemSize.LARGE} />
                  <InputField
                    type={InputFieldType.PASSWORD}
                    name={passwordField}
                    label={PASSWORD}
                    inputStyle={InputStyle.LOGIN}
                    size={ItemSize.LARGE}
                    visibilityToggle={false}
                  />
                  <Button className={styles.signinButton} size={ItemSize.LARGE} loading={isPending} htmlType={ButtonHtmlType.Submit}>
                    SIGN IN
                  </Button>
                </>
              );
            }}
          </Form>
        </div>
        <div className={styles.footer}>
          <span role="button" onClick={handleForgetNavigate}>
            Forgot your email or password?
          </span>
        </div>
      </div>
    </div>
  );
};

export default LoginForm;
